export type Testimonial = {
  name: string
  role: string
  photo: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Dr. Andrés Molina',
    role: 'Médico general · Bogotá, Colombia',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/e1b3a835-8aca-462f-a82b-01861a23458e.jpg',
    quote:
      'Dejé de abrir tres guías distintas en cada consulta. Ahora sigo el algoritmo, decido en un minuto y el paciente sale con una conducta clara.',
  },
  {
    name: 'Dra. Valentina Ruiz',
    role: 'Medicina familiar · Ciudad de México',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/8f2b9ca6-b1ac-4d9d-8a5a-c856109f1526.jpg',
    quote:
      'El tomo de embarazo me cambió la práctica. Antes derivaba casi todas las gestantes; hoy manejo la mayoría con metas de TSH claras.',
  },
  {
    name: 'Dr. Sebastián Ortega',
    role: 'Residente de Medicina Interna · Lima, Perú',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/f7896cbe-5680-47ff-8b48-bd013658186e.jpg',
    quote:
      'Los 25 casos resueltos valen por sí solos mucho más de lo que pagué. Es como tener a un endocrinólogo explicándote el razonamiento.',
  },
  {
    name: 'Dra. Mariana Estévez',
    role: 'Internista · Buenos Aires, Argentina',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/2165ae7f-6b5c-4f0c-9a1f-2f0d082e8a85.jpg',
    quote:
      'Lo tengo abierto en la tablet durante la consulta. El algoritmo de “TSH que no baja” me resolvió dos casos la primera semana.',
  },
]
